/**
 * iOS Detection Utilities
 *
 * Detects iOS devices and Safari browser for PWA features
 */

export function isIOS(): boolean {
  // Check for iOS devices
  const userAgent = window.navigator.userAgent.toLowerCase()
  return /iphone|ipad|ipod/.test(userAgent)
}

export function isIOSSafari(): boolean {
  if (!isIOS()) return false

  const userAgent = window.navigator.userAgent.toLowerCase()

  // Check if Safari (not Chrome, Firefox, etc.)
  // Safari doesn't add "CriOS" (Chrome) or "FxiOS" (Firefox) to user agent
  const isChrome = userAgent.includes('crios')
  const isFirefox = userAgent.includes('fxios')
  const isInAppBrowser = userAgent.includes('fbav') || userAgent.includes('instagram')

  return !isChrome && !isFirefox && !isInAppBrowser
}

export function isStandalone(): boolean {
  // Check if running in standalone mode (installed PWA)
  return (
    (window.navigator as any).standalone === true || // iOS
    window.matchMedia('(display-mode: standalone)').matches // All PWAs
  )
}

export function canInstallPWA(): boolean {
  // iOS Safari can install, but only if not already installed
  if (isIOSSafari() && !isStandalone()) {
    return true
  }

  // Desktop/Android can install via beforeinstallprompt event
  // (This is handled separately with the event)
  return false
}

export function getIOSVersion(): number | null {
  if (!isIOS()) return null

  const match = navigator.userAgent.match(/OS (\d+)_/)
  return match ? parseInt(match[1], 10) : null
}

export function supportsIOSPushNotifications(): boolean {
  const version = getIOSVersion()
  // Push notifications require iOS 16.4+
  return version !== null && version >= 16
}
